import React from 'react';
import { beatsToggleIcon, CircleElement } from '@chordbaker/design';

const dots = beatsToggleIcon.elements as CircleElement[];

interface BeatsToggleIconProps {
  size?: number;
  color?: string;
}

/** Three beat dots: the Beats toggle's glyph. */
const BeatsToggleIcon: React.FC<BeatsToggleIconProps> = ({
  size = beatsToggleIcon.defaultSize,
  color = 'currentColor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={beatsToggleIcon.viewBox}
    fill={color}
    aria-hidden="true"
  >
    {dots.map(dot => (
      <circle key={dot.cx} cx={dot.cx} cy={dot.cy} r={dot.r} />
    ))}
  </svg>
);

export default BeatsToggleIcon;
